export enum PersonalizationEngineReportTypeEnum {
  GAME = 2,
  CATEGORY = 3,
  PROVIDER = 4,
}
